import styled from "styled-components";

/* Container */
export const SearchContainer = styled.div`
  width: 460px;
  background: #ffffff;
  border-radius: 10px;
  font-family: inherit;
`;

/* Title */
export const Title = styled.h3`
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 600;
  font-family: inherit;
  
    margin-top: 0px;

`;

/* Option Card */
export const OptionCard = styled.label`
  display: flex;
  gap: 12px;
  padding: 14px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  margin-bottom: 12px;
  cursor: pointer;
  
    align-items: flex-start;


  ${({ active }) =>
    active &&
    `
      border-color: #22c55e;
      background: #f0fdf4;
    `}
`;

/* Radio */
// export const RadioInput = styled.input`
//   margin-top: 4px;
//   outline: none;
// `;\

export const RadioInput = styled.input.attrs({ type: "radio" })`
  appearance: none; /* Remove default radio styling */
  width: 18px;
  height: 18px;
  border: 2px solid #ccc; /* default border */
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  background-color: #fff; /* default background */
  margin:0px;
  margin-top:2px;

  &:checked {
    border-color: green; /* border turns green when checked */
    background-color: white; /* inner circle white */
    border :5px solid green;
  }

  &:checked::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 5px; /* size of inner circle */
    height: 5px;
    background-color: white; /* inner circle color */
    border-radius: 50%;
  }
`;



/* Text */
export const OptionTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
`;

export const OptionSubtitle = styled.div`
  font-size: 13px;
  color: #6b7280;
  margin-top: 2px;
`;

/* Search Row */
export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
`;

/* Input Wrapper */
export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 6px 10px;
  flex: 1;
  width:300px;
`;

/* Input */
export const Input = styled.input`
  border: none;
  outline: none;
  flex: 1;
  font-size: 14px;
  background:transparent;
      outline: none;
`;

/* Icons */
export const AtSymbol = styled.span`
  color: #6b7280;
  margin-right: 4px;
`;

export const SearchIconDiv = styled.span`
  color: #6b7280;
`;

/* Button */
export const FindButton = styled.button`
  background: #2e7d32;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 8px 18px;
  font-weight: 500;
  cursor: pointer;

  font-family: inherit;
  &:hover {
    background: #256628;
  }
`;
